import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../api/adminApi";

// placeholderData = a linha da listagem: o detalhe abre na hora e as contagens chegam
// em seguida.
export function useAdminUserQuery(id, placeholderData) {
  return useQuery({
    queryKey: ["admin", "users", id],
    queryFn: () => adminApi.getUser(id),
    enabled: Boolean(id),
    placeholderData,
  });
}
